import { db, type Box } from "./db";
import Papa from "papaparse";

import canvasCsv from "./assets/canvas.csv?url";
import imagesCsv from "./assets/images.csv?url";
import scrapedCsv from "./assets/scraped.csv?url";
import type { UpdateSpec } from "dexie";

interface CanvasCsvRow {
  "Council:": string;
  "Latitude:": string;
  "Longitude:": string;
  "GPS:": string;
  "Artist:": string;
  "Artwork title:": string;
  "Location:": string;
  "Area:": string;
  "Year:": string;
  "Status:": string;
  "Website Profile: ": string;
}

interface ImagesCsvRow {
  artist: string;
  src: string;
  thumb: string;
}

interface ScrapedCsvRow {
  id: string;
  artist: string;
  artworkTitle: string;
  location: string;
  year: string;
  council: string;
  artworkDescription: string;
  biography: string;
  links: string;
}

export async function sync() {
  await syncCanvas();
  await syncImages();
  await syncScraped();
}

async function syncCanvas() {
  const res = await fetch(canvasCsv);
  const text = await res.text();

  const { data } = Papa.parse<CanvasCsvRow>(text, { header: true });

  const put: Box[] = [];

  for (const row of data) {
    const lon = parseFloat(row["Longitude:"]);
    const lat = parseFloat(row["Latitude:"]);
    const url = row["Website Profile: "];

    // TODO: Not all artists have names
    const id = url?.match("/([^/]+)$")?.[1];

    if (isFinite(lon) && isFinite(lat) && id) {
      put.push({
        id,
        source: "import",
        lat,
        lon,

        url: row["Website Profile: "],
        location: row["Location:"],
        artist: row["Artist:"],
        title: row["Artwork title:"].replace(/^'/, "").replace(/'$/, ""),
        year: row["Year:"],

        // will be updated by scraped data
        council: "",
        description: "",
        biography: "",
        links: "",
      });
    }
  }

  db.boxes.bulkPut(put);
}

async function syncImages() {
  const res = await fetch(imagesCsv);
  const text = await res.text();

  const { data } = Papa.parse<ImagesCsvRow>(text, { header: true });

  const identified = data.map((data, id) => ({ id, ...data }));

  db.boxImages.bulkPut(identified);
}

async function syncScraped() {
  const res = await fetch(scrapedCsv);
  const text = await res.text();

  const { data } = Papa.parse<ScrapedCsvRow>(text, { header: true });

  const updates: { key: string; changes: UpdateSpec<Box> }[] = [];

  for (const row of data) {
    const changes: UpdateSpec<Box> = {};

    changes.council = row.council;
    changes.biography = row.biography;
    changes.description = row.artworkDescription;
    changes.links = row.links;

    updates.push({
      key: row.id,
      changes,
    });
  }

  db.boxes.bulkUpdate(updates);
}
